module.exports = __webpack_public_path__ + "static/logo.141bb19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 1423
// module chunks = 168707334958949